import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
import { OrganizationConfigState } from './types';

const selectOrganizationConfig = (state: AppState): OrganizationConfigState =>
    state.organizationConfig;

const selectIsMyTimesheetEnabled = createDeepEqualSelector(
    selectOrganizationConfig,
    (organizationConfig: OrganizationConfigState): boolean =>
        organizationConfig ? organizationConfig.isMyTimesheetEnabled : false
);

const selectIsNotificationsEnabled = createDeepEqualSelector(
    selectOrganizationConfig,
    (organizationConfig: OrganizationConfigState): boolean =>
        organizationConfig ? organizationConfig.isNotificationsEnabled : false
);

const selectEntityTypeCostCentreDepth = createDeepEqualSelector(
    selectOrganizationConfig,
    (organizationConfig: OrganizationConfigState): number | null =>
        organizationConfig ? organizationConfig.entityTypeCostCentreDepth : null
);

const selectIsHarvestEnabled = createDeepEqualSelector(
    selectOrganizationConfig,
    (organizationConfig: OrganizationConfigState): boolean =>
        organizationConfig ? organizationConfig.isHarvestEnabled : false
);

const selectIsRemovalsEnabled = createDeepEqualSelector(
    selectOrganizationConfig,
    (organizationConfig: OrganizationConfigState): boolean =>
        organizationConfig ? organizationConfig.isRemovalsEnabled : false
);

const selectIsTimesheetImportEnabled = createDeepEqualSelector(
    selectOrganizationConfig,
    (organizationConfig: OrganizationConfigState): boolean =>
        organizationConfig ? organizationConfig.isTimesheetImportEnabled : false
);

export {
    selectOrganizationConfig,
    selectIsMyTimesheetEnabled,
    selectIsNotificationsEnabled,
    selectEntityTypeCostCentreDepth,
    selectIsHarvestEnabled,
    selectIsRemovalsEnabled,
    selectIsTimesheetImportEnabled
};
